<script setup>

const props = defineProps({
	text: {
		type: String,
		required: true
	},
	url: {
		type: String,
		required: true
	},
});

const links = {
  whatsapp: `https://wa.me/?text=${props.text}%20${props.url}`,
  facebook: `https://www.facebook.com/sharer/sharer.php?u=${props.url}`,
  telegram: `https://t.me/share/url?url=${props.url}&text=${props.text}`,
  twitter: `https://twitter.com/intent/tweet?text=${props.text}&url=${props.url}`,
  instagram: `https://www.instagram.com/` // Instagram does not support direct web share
}
</script>
<template>
<div class="share-container">
    <a :href="links.whatsapp" target="_blank" class="icon whatsapp">
        <font-awesome-icon :icon="['fab', 'whatsapp']" />
    </a>

    <a :href="links.facebook" target="_blank" class="icon facebook">
        <font-awesome-icon :icon="['fab', 'facebook-f']" />
    </a>

    <a :href="links.telegram" target="_blank" class="icon telegram">
        <font-awesome-icon :icon="['fab', 'telegram']" />
    </a>

    <a :href="links.twitter" target="_blank" class="icon twitter">
        <font-awesome-icon :icon="['fab', 'x-twitter']" />
    </a>

    <a :href="links.instagram" target="_blank" class="icon instagram">
        <font-awesome-icon :icon="['fab', 'instagram']" />
    </a>
</div>
</template>
<style scoped>
.share-container {
  display: flex;
  gap: 16px;

}

.icon {
  width: 27px;
  height: 27px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  transition: transform 0.2s ease;
}

.icon:hover {
  transform: scale(1.1);
}

/* Brand Colors */
.whatsapp { background: #25D366; }
.facebook { background: #1877F2; }
.telegram { background: #229ED9; }
.twitter { background: #000000; }
.instagram {
  background: radial-gradient(circle at 30% 30%,
    #feda75, #fa7e1e, #d62976, #962fbf, #4f5bd5);
}

</style>